'use strict';
const angular = require('angular');

/*@ngInject*/
export function SurveysService($resource) {
  return $resource('/api/surveys/:id', {
    name: '@_id'
  },{
    getForParticipant: {
      method: 'GET',
      url: "/api/surveys/:id/:propertyId/:contactId/:emailHash",
    },
    sendCampaignMail: {
      method: 'POST',
      url: "/api/surveys/:id/campaign/send"
    },
    update: {
      method: 'PUT'
    }
  });
}

export default angular.module('conduu.SurveysService', [])
  .factory('SurveysService', SurveysService)
  .name;



// WEBPACK FOOTER //
// ./client/components/surveys/surveys.service.js